import { Link } from "@tanstack/react-router";
import { SectionMark } from "@/components/section-mark";
import { PhotoFigure } from "@/components/photo-figure";
import { MediaLinks } from "@/components/media-links";
import { LogoMarquee } from "@/components/logo-marquee";
import { Reveal } from "@/components/reveal";
import { mediaArticles } from "@/content/site-content";
import tvnFoto from "@/assets/sylwia-tvn.jpg.asset.json";

const homeArticleTopics = new Set([
  "Biznes i psychologia idą w parze",
  "Jak oswoić zmiany",
  "Jak rozmawiać z szefem, który ma przerośnięte ego?",
]);

const homeMediaArticles = mediaArticles.filter((item) => homeArticleTopics.has(item.topic));

export function MediaSection() {
  return (
    <section id="media" aria-labelledby="media-heading" className="content-visibility-auto scroll-mt-24 border-b border-ink/10 bg-surface">
      <div className="container-page section-pad">
        <Reveal className="grid items-start gap-8 md:grid-cols-[0.72fr_1.28fr] md:gap-12">
          <div className="flex flex-col">
            <SectionMark number="10" label="Media i publikacje" />
            <h2 id="media-heading" className="sr-only">
              Media i publikacje
            </h2>
            <PhotoFigure
              src={tvnFoto.url}
              alt="Sylwia Sitkowska jako ekspertka w programie Dzień Dobry TVN"
              figureClassName="mt-8 max-w-sm"
              imgClassName="aspect-[4/3] w-full object-cover object-[58%_30%]"
              width={1920}
              height={1440}
            />
            <Link to="/media-i-publikacje" className="btn-base btn-outline mt-8 self-start">
              Zobacz więcej
            </Link>
          </div>
          <div className="max-w-3xl">
            <p className="eyebrow">Artykuły i wywiady prasowe</p>
            <div className="mt-6">
              <MediaLinks
                items={homeMediaArticles}
                initial={3}
                linkLabel="Przeczytaj"
                moreLabel="Pokaż więcej artykułów"
              />
            </div>
          </div>
        </Reveal>

        <Reveal className="mt-10 border-t border-steel pt-8">
          <LogoMarquee exclude={["Rzeczpospolita", "Onet", "Wirtualna Polska"]} />
        </Reveal>
      </div>
    </section>
  );
}
